
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registries",
      function () {
        return require("private-next-pages/registries/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registries"])
      });
    }
  